export class TituloModule{

  constructor(
    public tituloHistorial : string
  ){}
}
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/